export default {
    namespaced: true,
    state: () => ({
        status: "Any",
        search: null,
        extendedFilter: {
            EFTheme: {
                label: "Краткое_содержание",
                value: null
            },
            RegNumber: {
                label: "Рег._номер",
                value: null
            },
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            Language: {
                label: "Язык_документа",
                value: null
            },
            Executers: {
                label: "Исполнитель",
                value: []
            },
            ResolutionAuthor: {
                label: "Автор_резолюции",
                value: []
            },
            Recipients: {
                label: "Получатель",
                value: []
            },
            NomenclatureId: {
                label: "Номенклатура",
                value: []
            },
            SignerEmployeeIds: {
                label: "Подписал",
                value: []
            }
        },
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        collection : "3",
    }),
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
            state.tableOptions.page = 1;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
            state.tableOptions.page = 1;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
            state.tableOptions.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getStatus: (s) => s.status,
        getSearch: (s) => s.search,
        getExtendedFilter: (s) => s.extendedFilter,
        getCollection: (s) => s.collection,
    }
}